/* eslint-disable no-console */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_APIURL,
});

api.interceptors.response.use(
  success => success,
  error => {
    console.log({ error });
    const { ...err } = error;
    console.log(err);


    return Promise.reject(error);
  },
);

export default api;
